import { CdkMenu, CdkMenuBar, CdkMenuItem, CdkMenuTrigger } from '@angular/cdk/menu';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, effect, inject, input, output, viewChild } from '@angular/core';
import { PopoverDirective, PopoverModule } from 'ngx-bootstrap/popover';
import { HelperService } from '../../../../core/services/helper.service';
import { LaunchDarklyService } from '../../../../core/services/launchdarkly.service';
import { ScaleRatio, ScaleRatiosImperial, ScaleRatiosMetric } from '../../core/constants';
import { TakeOffAddOnService } from '../../domain/takeoff-addon.service';
import { ScaleType, ScaleTypeValue } from '../domain/entities/scale-type';
import { TakeoffScaleService } from './takeoff-scale.service';

@Component({
    selector: 'app-scale-drop-down',
    standalone: true,
    imports: [CdkMenuTrigger, CdkMenu, CdkMenuItem, CommonModule, CdkMenuBar, PopoverModule, CdkMenuItem],
    templateUrl: './scale-drop-down.component.html',
    styleUrls: [
        '../../../../shared/composable-styles/button.scss',
        '../../../../shared/composable-styles/dropdown-menu.scss',
        './scale-drop-down.component.scss',
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScaleDropDownComponent {
    readonly takeOffAddOnService = inject(TakeOffAddOnService);
    readonly #lds = inject(LaunchDarklyService);
    readonly #helperService = inject(HelperService);
    readonly #takeoffScaleService = inject(TakeoffScaleService);

    scaleRatio = input<string>();
    isScaled = input<boolean>();
    isAIScaled = input<boolean>();
    canSetScaleRatio = input<boolean>();
    scaleSet = output<{ scaleRatio: ScaleRatio; applyTo: ScaleTypeValue }>();
    hasAnalysedScales = input<boolean>();
    eventManualScale = output<void>();

    aiDetectPopover = viewChild<PopoverDirective>('pop');
    trigger = viewChild<CdkMenuTrigger>(CdkMenuTrigger);

    architecturalScales = ScaleRatiosImperial;
    metricScales = ScaleRatiosMetric;
    ScaleType = ScaleType;

    isAutoMeasureEnabled = this.#lds.get('takeoffs-ui-uplift') ?? false;

    constructor() {
        effect(() => {
            if (this.isAIScaled()) this.aiDetectPopover()?.show();
        });
    }

    selectScale(scale: ScaleRatio, applyTo: ScaleTypeValue) {
        if (applyTo === ScaleType.this && scale.name === this.scaleRatio()) return;
        this.scaleSet.emit({ scaleRatio: scale, applyTo });
        this.trigger()?.close();
    }

    scaleManually() {
        this.eventManualScale.emit();
        this.trigger()?.close();
    }

    getScaleDetection() {
        this.trigger()?.close();
        this.takeOffAddOnService.getAddOn()?.subscribe(() => this.takeOffAddOnService.hasAddOn.set(true));
    }

    autoDetectScale() {
        this.trigger()?.close();
        this.#takeoffScaleService.autoScalePlan().subscribe();
    }
}
